import Page from './Page';

class Template extends Page {
    // Check if page is active
    is(slug) {
        // Returns true or false
        return $('body').hasClass(`template-${ slug }`);
    }
}

export default Template;
